import React from 'react';
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';


class TaggerSubheader extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div>
        <Navbar className="logo-color" expand="md">
          <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink className="text-white" href="/atpazintuvas">Atpažintuvas</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="text-white" href="/atpazintuvas/apie">Pagalba</NavLink>
            </NavItem>
          </Nav>
        </Navbar>
      </div>
    );
  }
}

export default TaggerSubheader;
